import { Paper as MuiPaper, PaperProps as MuiPaperProps } from '@mui/material';

import { BaseComponentProps } from './types';

export interface PaperProps
  extends BaseComponentProps,
    Pick<MuiPaperProps, 'color' | 'variant' | 'children' | 'onKeyDown'> {
  saveVerticalSpace?: boolean;
  saveHorizontalSpace?: boolean;
  noPadding?: boolean;
}

export const Paper = ({
  variant = 'outlined',
  children,
  saveVerticalSpace,
  saveHorizontalSpace,
  noPadding,
  ...rest
}: PaperProps) => {
  const padding = {
    padding: saveHorizontalSpace || saveVerticalSpace ? 0 : 2,
    paddingY: saveVerticalSpace ? 1 : 2,
  };
  return (
    <MuiPaper
      variant={variant}
      sx={{
        ...(!noPadding && padding),
      }}
      {...rest}
    >
      {children}
    </MuiPaper>
  );
};
